import React from "react";
import Header from "../components/Header";

function About(props) {
  return (
    <div className="about">
      <Header basketCount={props.basketCount} resetList={props.resetList}/>
      <h2 style={{ marginBottom: "1%" }}>Welcome to the Media Store App</h2>
      <p>
        This app was created by Shavana.
        The app will display a list of products
        that a user can save to their basket. You should be able to see a
        running total of the costs of items in the basket as well as the number
        of items. Click on
        <img
          alt="basket icon"
          className="icon"
          src="icons/basket.png"
        />
        to add a product and click on
        <img
          alt="remove icon"
          className="icon"
          src="icons/remove.png"
        />
        to remove a product from the basket. Search for by products name, genre
        or description using the search bar!
      </p>
    </div>
  );
}

export default About;